import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchProducts } from "../../lib/api";
import { useBranchFilter } from "../../hooks/useBranchFilter";

const Products = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const { branchId } = useBranchFilter();

  useEffect(() => {
    (async () => {
      try {
        const filters = branchId ? { branch_id: branchId } : {};
        const list = await fetchProducts(filters);
        setProducts(
          list.map(p => ({
            id: p.id,
            name: p.product_name || p.name || "",
            category: p.category || p.category_id,
            stock: p.stock ?? p.quantity ?? 0,
            price: p.price ?? p.initial_price ?? 0,
            image: p.primary_image_url || p.image_url || "",
          }))
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    })();
  }, [branchId]);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Inventory</h1>
        <button
          onClick={() => navigate("/addnew")}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Add New Product
        </button>
      </div>
      <div className="overflow-x-auto bg-white rounded-lg shadow border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {products.map((product) => (
              <tr key={product.id}>
                <td className="px-6 py-4 whitespace-nowrap"><img src={product.image} alt={product.name} className="w-12 h-12 object-contain rounded" /></td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{product.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{product.category}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{product.stock}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600 font-semibold">₹{product.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {products.length === 0 && (
          <div className="text-center py-8 text-gray-500">No products in inventory.</div>
        )}
      </div>
    </div>
  );
};

export default Products; 